import React from 'react';
import { LiabilitiesList } from 'src/domains/sportsbook/trading/view/Liabilities/LiabilitiesList/LiabilitiesList';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/AppState/AppState';
import { LiabilitiesState } from './Liabilities.state';
import { LiabilitiesFiltersBox } from './LiabilitiesBox';
import { LiabilitiesWidgets } from './LiabilitiesWidgets';
import { LiabilitiesContent, LiabilitiesListWrapper, LiabilitiesWidgetsWrapper } from 'src/domains/sportsbook/trading/view/Liabilities/Liabilities.style';

export const Liabilities = observer('Liabilities', () => {
    const appState = useAppStateContext();

    const [liabilitiesState] = React.useState(
        () => new LiabilitiesState(appState.reduxAction, appState.websocketV2)
    );

    const { competitionList, filters, setFilterForField } = liabilitiesState;

    return (
        <>
            <LiabilitiesFiltersBox
                filters={filters}
                competitions={competitionList}
                onChange={setFilterForField}
            />
            <LiabilitiesContent>
                <LiabilitiesListWrapper>
                    <LiabilitiesList liabilitiesState={liabilitiesState} />
                </LiabilitiesListWrapper>

                <LiabilitiesWidgetsWrapper>
                    <LiabilitiesWidgets />
                </LiabilitiesWidgetsWrapper>
            </LiabilitiesContent>
        </>
    );
});
